const buildShipToPartyInfo = (shipment, operation_type = null) => {
  const i = shipment.ship_to_party_info;
  return {
    so_id: i.humbee_so_id ?? null,
    operation_type,

    deliver_to: i.company_info.id,
    deliver_to_esi_id: i.company_info.esi_id,
    pricing_geography_id: i.pricing_geography_info?.pricing_geography_id,
    delivery_address: {
      address_line_1:
        i.address_info?.address?.address_line_1,
      address_line_2:
        i.address_info?.address?.address_line_2,
      address_line_3:
        i.address_info?.address?.address_line_3,
    },
    order_product_delivery_type: i?.delivery_info?.delivery_type || null,
    requested_district_id: i.address_info.district_info.id,
    location_id: i.address_info.location_info.location_id,
    requested_pincode: i.address_info.pincode ,
    incoterms: i.delivery_info.incoterms,
    order_delivery_contact_no: i.company_info.phone ?? null,
    order_delivery_contact_person_name: i.receiver_info?.name ?? null,
    
  };
};

export default buildShipToPartyInfo;
